import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { OperationRecordsService } from './services/operation-records-service.interface';
import { OperationRecordsServiceImpl } from './services/operation-records-service';
import { OperationRecordsRepository } from './repositories/operation-records-repository.interface';
import { OperationRecordsRepositoryImpl } from './repositories/operation-records-repository';
import { OperationRecordsApi } from './repositories/apis/operation-records-api.interface';
import { OperationRecordsApiImpl } from './repositories/apis/operation-records-api';
import { OperationRecordsMessageService } from './services/operation-message-service.interface';
import { OperationRecordsMessageServiceImpl } from './services/operation-message-service';
export const operationRecords = new ContainerModule((bind) => {
    bind(OperationRecordsService).to(OperationRecordsServiceImpl);
    bind(OperationRecordsMessageService).to(OperationRecordsMessageServiceImpl);
    bind(OperationRecordsRepository).to(OperationRecordsRepositoryImpl);
    bind(OperationRecordsApi).to(OperationRecordsApiImpl);
});
